import {
  getRedPacketInfo
} from "../../api/index"
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    appId: {
      type: String,
      required: true,
      value: "",
    },
    alive_id: {
      type: String,
      required: true,
      value: "",
    },
    userId: {
      type: String,
      required: true,
      value: "",
    },
    item: {
      type: Object,
      value: {}
    },
    /**
     * horizontal 横屏
     * vertical 竖屏
     */
    screenType: {
      type: String,
      value: 'vertical'
    }
  },
  observers: {
    'item'(item) {
      if (item && JSON.stringify(item) != '{}') {
        if(item.red_packet_id){
          console.log("item.red_packet_id",item.red_packet_id);
          const params = {
            app_id: this.data.appId,
            alive_id: this.data.alive_id,
            red_packet_id: item.red_packet_id,
            user_id: this.data.userId,
            current_user_id: this.data.userId
          }
          getRedPacketInfo(params).then(res => {
            this.setData({
              nowItem: res.data.data
            },()=>{
              if(!res.data.data.is_received){
                this.setData({
                  show: true
                })
              }else{
                this.setData({
                  show: true,
                  openState:2
                })
              }
            })
          })
          return
        }
        const params = {
          app_id: this.data.appId,
          alive_id: this.data.alive_id,
          red_packet_id: this.data.item.id,
          user_id: this.data.userId,
          current_user_id: this.data.userId
        }
        getRedPacketInfo(params).then(res => {
          this.setData({
            nowItem: res.data.data,
            show: true
          },()=>{
            if(res.data.data.is_received && res.data.data.code !== 0){
              this.setData({
                show: true,
                openState:2
              })
            };
          })  
        })
      } else {
        this.setData({
          show: false
        })
      }
    }
  },
  /**
   * 组件的初始数据
   */
  data: {
    show: false,
    openState: 0,
    nowItem: null,
    resultItem: null,
    backIcon: false
  },
  /**
   * 组件的方法列表
   */
  methods: {
    closePop() {
      this.setData({
        show: false
      }, () => {
        this.triggerEvent("close")
      })
    },
    goBack() {
      this.setData({
        openState: 0,
        backIcon: false
      })
    },
    receiveRedPacket({
      detail
    }) {
      console.log("receiveRedPacket", detail);
      this.setData({
        openState: 1,
        resultItem: detail.resultItem
      })
    },
    seeLuckList({
      detail
    }) {
      if (detail.backIcon) {
        this.setData({
          openState: 2,
          backIcon: true
        })
      } else {
        this.setData({
          openState: 2
        })
      }
    },
  }
})